// -- Custom Functions -- //
const calendarCTA = () => {
    const calendarTiles = [...$('.tile.single.blogpost[data-tags="calendar-cta"]')];
    if (calendarTiles) {
        calendarTiles.forEach((tile) => {
            $(tile).addClass('calendar-cta');
            let $img = $(tile)
                .find('img')
                .attr('src');
            if (/mediaproxy/.test($img)) {
                const $newImg = decodeURIComponent($img.split('url=')[1]);
                $img = $newImg.split('&')[0].split('?')[0];
                $(tile)
                    .find('.img>img')
                    .attr('src', `${$img}`)
                    .addClass('ob-raw-image');
            }
        });
    }
};
const moveEmbeddedItem = (itemCheck) => {
    if ($('#page-type-identifier').data().itemType === itemCheck) {
        $('.entry-wrapper').append($('.single-embed-wrapper'));
    }
    if ($('#page-type-identifier').data().itemType === itemCheck) {
        $('.entry').prepend($('.single-embed-wrapper'));
    }
};

const newRelatedArrows = () => {
    if ($('body').hasClass('single-page')) {
        $('#relatedNavPrev').html(`<i class="fas fa-arrow-circle-left"></i>`);
        $('#relatedNavNext').html(`<i class="fas fa-arrow-circle-right"></i>`);
    }
};

const moveFlipbookTitle = () => {
    if ($('body').hasClass('uberflip')) {
        $('.entry h2')
            .first()
            .detach()
            .prependTo('.level-three');
        $('.entry-wrapper h1')
            .detach()
            .prependTo('.level-three');
    }
};


// eslint-disable-next-line consistent-return
const populateSidebarData = (itemData) => {
    const { labels, presentedBy } = window.onBrandData;
    const { tags, itemId } = itemData;
    if (!tags) {
        return;
    }
    const itemTags = tags.split(',');

    const itemLabel = itemTags.filter((tag) => labels.includes(tag));
    if (itemLabel) {
        $('.ob-custom-label').html(itemLabel);
    } else {
        $('.ob-custom-label').html(itemData.itemType);
    }

    const readTime = itemTags.filter((tag) => tag.includes('read'));

    if (readTime) {
        $('.ob-custom-read-time').html(readTime);
    }

    const author = document.querySelector('blockquote.author');
    if (author) {
        if (presentedBy[itemId]) {
            $('.ob-custom-author').html(`<p>Co-presented with</p>`);

            if (typeof presentedBy[itemId] !== 'string') {
                window.onBrandData.presentedBy[itemId].forEach((presenter) => {
                    $(`<img class="ob-custom-copresenter" src="${presenter}">`).appendTo('.ob-custom-author');
                });
            } else {
                $(`<img class="ob-custom-copresenter" src="${presentedBy[itemId]}">`).appendTo(
                    '.ob-custom-author'
                );
            }
        } else if (author) {
            $('.uf-author-avatar')
                .detach()
                .appendTo('.ob-custom-author');
            $('span.author')
                .detach()
                .appendTo('.ob-custom-author');
            $('.uf-author-bio')
                .detach()
                .appendTo('.ob-custom-author');

            const authorH2 = author.querySelector('h2');
            if (authorH2 !== null) {
                author.removeChild(authorH2);
            }
        }
    }
};

// workaround to target first paragraph with text in it for special styles
const firstLetterStyles = () => {
    if ($('body').hasClass('single-page')) {
        const paragraphWithImg = document.querySelector('.entry p:first-of-type img');
        if (paragraphWithImg) {
            paragraphWithImg.parentElement.nextElementSibling.classList.add('first-letter');
        }
    }
};

const buildSidebar = () => {
    if ($('body').hasClass('single-page')) {
        $(`<div class="ob-custom-sidebar"></div>`).prependTo($('#item-content'));
        $('.meta-wrapper')
            .detach()
            .appendTo($('.ob-custom-sidebar'));
        $(`<div class="ob-custom-label"></div>`).prependTo($('.meta'));
        $(`<div class="ob-custom-read-time"></div>`).appendTo($('.meta'));
        $(`<div class="ob-custom-author clearfix"></div>`).appendTo($('.meta-inner'));
        $('.share-item')
            .detach()
            .appendTo($('.meta-inner'));
        $('.share-item').css({ display: 'block', position: 'static' });
        $('.share-text').html('Share');
        $('.share-item .facebook').html(`<i class="fab fa-facebook-square"></i>`);
        $('.share-item .twitter').html(`<i class="fab fa-twitter"></i>`);
        $('.share-item .email').html(`<i class="fas fa-envelope"></i>`);
        $('.share-item .linkedin').html(`<i class="fab fa-linkedin"></i>`);
        const itemData = document.getElementById('page-type-identifier').dataset;
        if (itemData) {
            populateSidebarData(itemData);
        }
    }
};

const openInNewWindow = (streamID) => {
    const tiles = [...document.querySelectorAll('.tile:not(#loading-notifier)')];
    if (tiles) {
        tiles.forEach((tile) => {
            if (tile.dataset.sourceStreamId === streamID) {
                const links = [...tile.querySelectorAll('a.item-link')];
                links.forEach((link) => {
                    link.setAttribute('target', '_blank');
                });
            }
        });
    }
};

///sales stream avatar toggle on/off
const salesStreamAvatarToggle = () => {
    const streamsToCustomize = window.onBrandData.salesStreamsWithAvatar;
    const currentStream = document.querySelector('#page-type-identifier').dataset.collectionId;
    if (currentStream) {
        $(streamsToCustomize).each((index, item) => {
            if (item !== undefined && item === currentStream) {
                $('.stream-banner-avatar').show();
            }
        });
    }
};
// sticky on scroll
$(window).scroll(function() {
    const scroll = $(window).scrollTop();
    let headClass = '';
    if (scroll === 0) {
        headClass = document.querySelectorAll('sticky');
        if (headClass.length >= 0) {
            document.getElementsByClassName('custom-header')[0].classList.remove('sticky');
        }
    } else {
        headClass = document.querySelectorAll('sticky');
        if (headClass.length === 0) {
            document.getElementsByClassName('custom-header')[0].classList.add('sticky');
        }
    }
});

//footer mobile
$('.foot-col').append("<small></small>");
$('.foot-col small').on('click', function() {
    $(this).prev('.foot-links').slideToggle();
    $(this).toggleClass("i-up");
});

// for mobile menu
$(".hamburger").click(function() {
    $("body").toggleClass("nav-open");
});
$('.x-close').click(function() {
    $('body').removeClass('nav-open');
});

$('.menu-item-has-children').append("<small></small>");
$('.menu-item-has-children small').on('click', function() {
    $(this).prev('.csub-menu').parent().toggleClass("open");
});

$('.back > a').on('click', function() {
    $(this).parents('.menu-item-has-children').removeClass('open');
});

function title() {

    const tiles = [...document.querySelectorAll('.tile:not(.cta)')];
    // - Iterate over each tile
    if (tiles) {
        tiles.forEach((tile) => {
            if (tile.querySelector('h4 p')) {
                const heading = tile.querySelector('h4 p').innerHTML.trim();
                if (heading.length > 80) {
                    tile.querySelector('h4 p').innerHTML = heading.substring(0, 75) + ' ...';
                }
            }
        });
    }

}
//OB-5715 Manage the banner resize
function headerManage() {
    if (!document.body.classList.contains('single-page')) {
        let imgPath = document.querySelector('.header-wrapper').style.backgroundImage;
        imgPath = imgPath.split('"')[1];
        if (imgPath === undefined) {
            imgPath = 'https://cihost.uberflip.com/rollworks/OB-5715-new/assets/images/Updated-header-images/Updated-homepage-bg-image.png';
        }
        const imageHTML = '<img class="banner-image" >';
        if (document.querySelector('.banner-image') === null) {
            document.querySelector('.header-wrapper').insertAdjacentHTML('afterbegin', imageHTML);
            document.querySelector('.banner-image').setAttribute('src', imgPath);
        }

    }
}

export { calendarCTA, moveEmbeddedItem, newRelatedArrows, moveFlipbookTitle, firstLetterStyles, buildSidebar, openInNewWindow, salesStreamAvatarToggle, title, headerManage };


// WEBPACK FOOTER //
// ./script-partials/calenderCTA.js